import { render, staticRenderFns } from "./MenuGenerale.vue?vue&type=template&id=78904d26&"
import script from "./MenuGenerale.vue?vue&type=script&lang=js&"
export * from "./MenuGenerale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports